document.addEventListener('DOMContentLoaded', function() {
    console.log('DOM fully loaded and parsed');
    var menuItem = document.querySelector('.menu__item_meigara_name a');
    var menuList = document.querySelector('.meigara_name_list');

    menuItem.addEventListener('click', function(event) {
        console.log('Menu item clicked');
        event.preventDefault();
        event.stopPropagation();

        // 現在のdisplay状態に基づいて表示を切り替える
        if (menuList.style.display === 'none' || menuList.style.display === '') {
            // display: flex を important に設定
            menuList.style.setProperty('display', 'flex', 'important'); // 表示
        } else {
            // display: none を important に設定
            menuList.style.setProperty('display', 'none', 'important'); // 非表示
        }

        console.log('After toggle, display:', menuList.style.display); // 変更後のdisplay状態を確認
    });

    // メニュー外をクリックすると閉じる
    document.addEventListener('click', function() {
        menuList.style.setProperty('display', 'none', 'important');
    });

    menuList.addEventListener('click', function(event) {
        event.stopPropagation();
    });
});
